/**
 * Adds functionality to the wysiwyg editor control
 */
import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/core/each/each.js";
import "dabbyjs/src/attributes/data/data.js";
import "dabbyjs/src/traversal/closest/closest.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/manipulation/insert/insert.js";
import "dabbyjs/src/traversal/find/find.js";
import "dabbyjs/src/manipulation/text/text.js";
import "dabbyjs/src/traversal/next-prev/next-prev.js";
import importscript from "../../javascript/import-script.js";

const setup = obj => {
	if (obj.length) {
		const editors = [],
			load = obj => {
				obj.each((i, item) => {
					CKEDITOR.config.allowedContent = true;
					// removes useless controls from image popup
					CKEDITOR.on("dialogDefinition", e => {
						if (e.data.name === "image") {
							e.data.definition.removeContents("Link");
							const infoTab = e.data.definition.getContents("info");
							infoTab.remove("txtHSpace");
							infoTab.remove("txtVSpace");
							infoTab.remove("txtBorder");
						}
					});
					editors.push(CKEDITOR.replace(item, $(item).data("editor")));
				});
			};

		// copy from editor to textarea when the form is submitted, must attach immediately and bind editors later to be first on the submit event
		obj.each((i, item) => {
			$(item).closest("form").on("submit", () => {
				editors[i].updateElement();
			});
		});

		window.CKEDITOR_BASEPATH = obj.data("editor").baseHref + "javascript/ckeditor/";
		importscript(window.CKEDITOR_BASEPATH + "ckeditor.js", () => load(obj));
	}
},

// enables selection of images and links when inserting into an HTML document
filebrowser = (obj, button) => {
	if (obj.length) {
		const params = new URLSearchParams(window.location.search.slice(1)),
			browse = params.get("browse"),
			num = params.get("CKEditorFuncNum");

		// render buttons
		if (window.opener && ["img", "link"].indexOf(browse) > -1 && num) {
			const span =
			(browse === "img" ? obj.filter("[href*='.jpg'],[href*='.gif'],[href*='.png'],[href*='.svg']") : obj).after(
				$("<span>", {
					"class": button,
					text: "Insert " + (broowse === "img" ? "Image" : "Link"),
					click: function () {
						const $this = $(this);
						window.opener.CKEDITOR.tools.callFunction(num, $this.prev().attr("href").replace(/(_[^&]*&|\?_[^&]*)/, ""), function () {
							const dialog = this.getDialog();
							if (dialog.getName() === "image") {
								const alt = dialog.getContentElement("info", "txtAlt");
								if (alt) {
									alt.setValue($this.closest("form").find("[data-browse=desc]").text());
								}
							}
						});
						window.close();
					}
				})
			);
		}
	}
};

export {setup, filebrowser};